import React from 'react'
import { observer } from 'mobx-react-lite'
import { Instance } from 'mobx-state-tree'
import { ISelectorOption } from '@trivie/core'
import { ContestCreateForm } from '@trivie/core/src/models/ContestCreateForm'
import { AutocompleteSelector } from '../../../../../components/autocomplete-selector'

type ContestCompetitorsProps = {
  form: Instance<typeof ContestCreateForm>
  editingId?: any
}

export const ContestCompetitors = observer((props: ContestCompetitorsProps) => {
  const { form, editingId } = props

  const preselectIds = [
    ...(form.group_ids ?? []).map((g: any) => ({ id: g.group_id ?? g.id, type: 'Groups' })),
    ...(form.user_ids ?? []).map((u: any) => ({ id: u.user_id ?? u.id, type: 'Users' })),
  ]

  const handleSelectionChange = (selected: ISelectorOption[]) => {
    form.set('group_ids', selected.filter((s) => s.type === 'Groups') as any)
    form.set('user_ids', selected.filter((s) => s.type === 'Users') as any)
  }

  return (
    <AutocompleteSelector
      variant="users-groups"
      open
      preselectIds={preselectIds.length > 0 ? preselectIds : undefined}
      onSelectionChange={handleSelectionChange}
      style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
    />
  )
})
